import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Explicativa from './components/Explicativa';
import Consorcios from './components/Consorcios';
import Simulador from './components/Simulador';
import CTAWhatsApp from './components/CTAWhatsApp';
import ProvasSocial from './components/ProvasSocial';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <Explicativa />
      <Consorcios />
      <Simulador />
      <CTAWhatsApp />
      <ProvasSocial />
      <Footer />
    </main>
  );
}
